import { useState } from 'react'

/**
 * Estado del pago de facturas por link (pagos-zeus-3): `pay(billingId)` abre el
 * `PayBillingDialog` (elegir pasarela → link/QR → confirmación automática).
 * La página que lo usa renderiza el diálogo con `payBillingId`/`close`.
 */
export function usePayBilling() {
  const [payBillingId, setPayBillingId] = useState<number | null>(null)

  const pay = (billingId: number) => setPayBillingId(billingId)
  const close = () => setPayBillingId(null)

  return { pay, close, payBillingId }
}
